import Toast from "../../common/components/ui/toast";
import Dashboard from "../../common/components/layout/Dashboard";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import { AuditsMenu } from "./components/AuditsMenu";

function AuditsPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <AuditsMenu />
        <Toast />
      </Dashboard>
    </ToastProvider>
  )
}

export default AuditsPage;
